/** Widget placeholders keep the real dashboard layout visible during its first load. */

import { Skeleton } from '../../shared/ui/skeleton';

const placeholder = 'bg-foreground/5 motion-reduce:animate-none';

export function ProfitLossSkeleton() {
  return (
    <div className="flex h-full min-h-0 flex-col px-5 pb-3 pt-1 @[700px]/dash:pb-4" aria-hidden="true">
      <div className="mb-2.5 shrink-0 @[700px]/dash:mb-3">
        <Skeleton className={`${placeholder} h-[26px] w-24 @[700px]/dash:h-7`} />
        <Skeleton className={`${placeholder} mt-1 h-4 w-44 @[700px]/dash:mt-1.5`} />
      </div>
      <div className="relative min-h-[82px] flex-1 @[700px]/dash:min-h-[130px]">
        <div className="absolute inset-x-0 top-1/2 border-t border-border/70" />
        <div className="absolute inset-0 flex items-center justify-around gap-3">
          {Array.from({ length: 6 }, (_, index) => (
            <Skeleton key={index} className={`${placeholder} h-12 w-6`} />
          ))}
        </div>
      </div>
      <div className="mt-1.5 flex shrink-0 justify-around gap-3">
        {Array.from({ length: 6 }, (_, index) => (
          <Skeleton key={index} className={`${placeholder} h-3 w-7`} />
        ))}
      </div>
    </div>
  );
}

export function DashboardListSkeleton({ rows, bars = false }: { rows: number; bars?: boolean }) {
  return (
    <div className={bars ? 'flex flex-col gap-3.5 px-4 py-3' : 'px-3 pt-3 pb-2'} aria-hidden="true">
      {!bars && <Skeleton className={`${placeholder} mb-2 h-3 w-20`} />}
      {Array.from({ length: rows }, (_, index) => (
        <div key={index} className={bars ? undefined : 'flex items-start justify-between gap-3 py-3'}>
          <div className="flex flex-1 items-start justify-between gap-3">
            <div className="min-w-0 flex-1">
              <Skeleton className={`${placeholder} h-4 w-2/5 max-w-52`} />
              <Skeleton className={`${placeholder} mt-1.5 h-3 w-1/3 max-w-36`} />
            </div>
            <Skeleton className={`${placeholder} h-3 w-10 shrink-0`} />
          </div>
          {bars && <Skeleton className={`${placeholder} mt-2 h-3 w-full rounded-full`} />}
        </div>
      ))}
      <div className="mt-3 flex gap-4 border-t border-border/30 pt-3 text-xs text-muted-foreground">
        {bars ? <><span>Paid</span><span>Outstanding</span></> : <span className="min-h-8 text-sm">Include project milestones</span>}
      </div>
    </div>
  );
}
